var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-flex ts-space-x-3"},[_c('p',{staticClass:"ts-mb-0"},[_vm._v(_vm._s(_vm.$t('wholesale.fxRate'))+" : "),_c('span',{staticClass:"ts-font-extrabold ts-text-red-600"},[_vm._v(_vm._s(_vm.model.fx_rate))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }